import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, Link } from "react-router-dom";
import NavBar from "./Components/NavBar";
import Home from './Screens/Home';
import About from "./Screens/About";
// import Services from "./Screens/Services";
// import Work from "./Screens/Work";
import Testimonial from "./Screens/Testimonial";
import Contact from "./Screens/Contact";
import Footer from "./Components/Footer";
import CookieConsent from "react-cookie-consent";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import ScrollToTop from "./Components/ScrollToTop";


const App = () => {
  return (
    <Router>
      <ScrollToTop/>
      <NavBar />
      <Routes>
      <Route path="/" element={<Navigate to="/inicio" />} />
        <Route path="/inicio" element={<Home />} />
        <Route path="/servicios" element={<About />} />
        <Route path="/sobrenosotros" element={<About />} />
        {/* <Route path="/proceso" element={<Work />} /> */}
        <Route path="/testimonios" element={<Testimonial />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/politica-de-privacidad" element={<PrivacyPolicy />} /> 
      </Routes>
      <Footer/>
      <CookieConsent
        location="bottom"
        buttonText="Aceptar"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        Este sitio web utiliza cookies para mejorar la experiencia del usuario.{" "}
        <Link to="/politica-de-privacidad" style={{ color: "#ffffff", textDecoration: "underline" }}>
          Leer más
        </Link>
      </CookieConsent>
    </Router>
  );
};

export default App;
